import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button, Upload, Spin } from 'antd'
import { UploadOutlined, QuestionCircleFilled } from '@ant-design/icons';
import { withTranslation } from 'react-i18next'
import JoditEditor from "jodit-react";
import moment from 'moment'
import md5 from 'js-md5'
import uuidv4 from 'uuid/v4'
import auth from '../../../utils/auth'
import alertMessage from '../../../utils/alertMessage'
const { Search } = Input;
const { Option } = Select;
const { confirm } = Modal

@inject('emailTemplateStore')
@observer
class FormModal extends Component {
  state = {
    editorLoaded: false,
    content: '',
    editorInstance: null // 保存编辑器实例
  }
  formRef = React.createRef()
  beforeUpload = (file, FileList) => {
    return true
  }
  getHeader = () => {
    const authInfo = auth.getAuthInfo()
    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
    const uuid = uuidv4()
    const nounce = md5(timestamp + uuid)
    return {
      timestamp,
      uuid,
      nounce,
      Authorization: `Bearer ${authInfo.token}`
    }
  }
  componentDidMount() {
    const { emailTemplateStore, title } = this.props
    const { detailsObj, searchItem } = emailTemplateStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        'marketGroupId': searchItem?.marketGroupId,
        // "content": JSON.parse(JSON.stringify(detailsObj?.content)) || null,
        "emailName": detailsObj?.name,
        "subject": detailsObj?.subject?.name,
        // 'htmlToTemplate': 'http://',
      })
      this.setState({
        'content': JSON.parse(JSON.stringify(detailsObj?.content)) || null,
        'editorLoaded': true
      })
    } else {
      this.setState({
        'editorLoaded': true
      })
    }
  }
  handleOk = () => {
    const { emailTemplateStore, handleCancel, title } = this.props
    const { detailsObj } = emailTemplateStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": title === 'edit' ? detailsObj?.id : null,
        "marketGroupId": fieldsValue?.marketGroupId,
        "content": fieldsValue?.content,
        "name": fieldsValue?.emailName,
        "subject": fieldsValue?.subject,
      }
      if (title === 'edit') {
        emailTemplateStore.onEditJobAction({ ...params, id: detailsObj.id }, title).then(res => {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        emailTemplateStore.onAddJobAction({ ...params }).then(res => {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  normFile = (e) => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };
  suffixSelector = (
    <Form.Item label='插入变量' name="suffix" noStyle>
      <Select style={{ width: 150, }} >
        <Option value="插入变量">插入变量</Option>
        <Option value="CNY">¥</Option>
      </Select>
    </Form.Item>
  );
  suffixSelectorHttp = (
    <Form.Item label='解析到正文' name="suffix" noStyle>
      <Button type="primary">解析到正文</Button>
    </Form.Item>
  );
  onSearch = (value) => {
    const { emailTemplateStore, t } = this.props
    const _this = this
    if (value) {
      confirm({
        title: t(`general.prompt`),
        icon: <QuestionCircleFilled />,
        content: t(`general.isReplace`),
        okText: t(`general.ok`),
        cancelText: t(`general.cancel`),
        onOk() {
          emailTemplateStore.onHtmlToTemplateAction({
            "htmlUrl": value
          }).then(res => {
            if (res?.data?.code === 0) {
              // _this.formRef.current.setFieldsValue({
              //   content: res?.data?.data
              // })
              _this.setState({
                content: res?.data?.data
              })
            }
          })
        },
        onCancel() {
        },
      })
      return false
    }
  }
  onClickImport = (info) => {
    const _this = this
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      if (info.file.response.code !== 0) {
        alertMessage.error(info.file.response.messageEn)
      } else {
        const value = info.file.response.data
        const contentDiv = this.formRef.current.getFieldValue('content') != undefined ? this.formRef.current.getFieldValue('content') : "";
        const newContentDiv = `${contentDiv}<a href="https://${value?.url}" target="_blank">${value?.filename}</a>`
        this.formRef.current.setFieldsValue({
          content: newContentDiv
        })
        this.setState({
          content: newContentDiv
        })
        alertMessage.success('导入成功!')
      }
    } else if (info.file.status === 'error') {
      alertMessage.error('导入失败!')
    }
  }
  render() {
    const { emailTemplateStore, addModalVisible, handleCancel, title, t } = this.props
    const { isFetching, isFetchingTo, groupList } = emailTemplateStore
    const UPLOAD_TEMPLATE_URL = `${window.g.apiBaseUrl}/market/management/file/upload`
    const editorConfig = {
      readonly: false, // 是否只读模式
      autofocus: true,
      cursorAfterAutofocus: 'end', // 'end';
      saveSelectionOnBlur: true,
      // toolbarAdaptive: false,
      // toolbarInline: false, // 保持内联工具栏启用
      // toolbarInlineForSelection: false, // 禁用选中文本时的工具栏
      // events: {
      //   beforeToolbarShow: (toolbar, element) => {
      //     // 根据元素类型控制工具栏显示
      //     if (element?.tagName === 'A') {
      //       return false; // 阻止超链接工具栏显示
      //     }
      //     return true;
      //   }
      // },
      // style: {
      //   border: "1px solid #d9d9d9", // 匹配 Ant Design 风格
      //   borderRadius: 4,
      // },
      placeholder: "请输入内容...", // 占位文本
      height: 400,  // 编辑器高度（像素）
      minHeight: 200,  // 最小高度
      // 剪贴板配置
      // enablePasteFile: true,      // 启用粘贴文件
      // disableImagesPaste: false,  // 允许粘贴图片（默认禁止）
      // images: {
      //   pasteDataURI: false,      // 禁止将图片转为 Base64
      // },
      // buttons: [
      //   "source", // 源码模式
      //   "|",      // 分隔符
      //   // "file",   // 插入文件
      //   "preview", //预览
      //   "print",  //打印
      //   "fullsize", // 全屏
      //   "|",
      //   "cut",  //剪切
      //   "copy",  //复制
      //   "paste",  //粘贴
      //   "|",
      //   "undo",
      //   "redo",
      //   "selectall",
      //   "|",
      //   "bold",
      //   "italic",
      //   "underline",
      //   "strikethrough",
      //   "superscript",
      //   "subscript",
      //   "|",
      //   "ul",
      //   "ol",
      //   "|",
      //   "outdent",
      //   "indent",
      //   "|",
      //   "align",
      //   "|",
      //   "link",
      //   "image",  // 图片上传
      //   "table",
      //   "hr", //插入水平线
      //   // "video",  // 视频嵌入
      //   // "media",
      //   // "embed",  // 嵌入第三方内容（iframe）
      //   // "symbols",  //特殊符号
      //   "|",
      //   "brush", //格式刷
      //   "font",
      //   "fontsize",
      //   "paragraph",
      // ],
      // filebrowser: {
      //   images: {
      //     icons: 'image',
      //     text: '上传图片'
      //   }
      // },
      uploader: {
        url: `${window.g.apiBaseUrl}/market/management/file/upload`, // 上传接口地址
        method: "POST",
        // format: 'json',           // 响应格式
        // filesVariableName: 'file',// 文件字段名（单文件模式）
        limitFiles: 1,            // 限制一次只能上传1个文件
        // accept: 'image/*',        // 只允许选择图片文件
        headers: () => {
          const headers = this.getHeader();
          // 移除 Content-Type 头，让浏览器自动设置
          delete headers['Content-Type'];
          return headers;
        },
        insertImageAsBase64URI: false, // 关闭 Base64 转换
        imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'], // 允许的图片格式
        showProgress: true, // 显示默认进度条
        maxFileSize: 5 * 1024 * 1024, // 5MB
        prepareData: (data) => {
          // 自定义上传数据格式
          // 遍历所有文件并添加到 formData
          const formData = new FormData();
          const file = data.getAll('files[0]')[0];
          data.append('file', file)
          data.delete('files[0]');
          return data;
        },
        getMessage: (res) => {
          if (res.code == 0) {
            const value = res.data
            const contentDiv = this.formRef.current.getFieldValue('content') != undefined ? this.formRef.current.getFieldValue('content') : "";
            var newContentDiv = "";
            if (value.contentType.indexOf("image") > -1) {
              newContentDiv = `${contentDiv}<img src="https://${value?.url}" alt="${value?.filename}"></img>`
            } else {
              newContentDiv = `${contentDiv}<a href="https://${value?.url}" target="_blank" >${value?.filename}</a>`
            }
            this.formRef.current.setFieldsValue({
              content: newContentDiv
            })
            this.setState({
              content: newContentDiv
            })
            alertMessage.success('上传成功!')

          } else {
            alertMessage.error('上传失败: ' + res.messageEn)
          }

        },
        error: (e) => {
          alertMessage.error('上传失败: ' + e.message)
        },
        // defaultHandlerSuccess: (editor, resp) => {
        //   // 插入图片到编辑器
        //   if (resp.files && resp.files.length) {
        //     resp.files.forEach(filename => {
        //       const img = editor.create.fromHTML(
        //         `<img src="${resp.baseurl}/${filename}" style="max-width:100%;"/>`
        //       );
        //       editor.s.insertNode(img);
        //     });
        //   }
        // },
        // buildData: function (data) {
        //   return new Promise(function (resolve, reject) {
        //     var reader = new FileReader();
        //     reader.readAsDataURL(data.getAll('files[0]')[0]);
        //     reader.onload = function () {
        //       return resolve({
        //         image: reader.result
        //       });
        //     };
        //     reader.onerror = function (error) {
        //       reject(error);
        //     };
        //   });
        // }
      },
      // imageDefaultWidth: '80%', // 设置图片默认宽度
      // showXPathInStatusbar: false,
      language: "zh_cn", // 中文
      // 允许粘贴图片
      // enableDragAndDropFileToEditor: true,
      // 允许直接粘贴 Base64 图片（可选）
      // enablePasteImage: true,
    };
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`emailSend.editTemplate`) : t(`emailSend.createTemplate`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'80%'}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Spin spinning={isFetching}>
            <Form ref={this.formRef} key="addMapping" layout='vertical'>
              <Row gutter={[10, 10]}>
                <Col span={12}>
                  <Form.Item name="marketGroupId" label={t(`emailSend.marketingGroup`)}
                    rules={[{ required: true, message: `${t(`general.pleaseSelect`)} ${t(`emailSend.marketingGroup`)}` }]}
                  >
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    } disabled={title === 'edit'}>
                      {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="emailName" label={t(`emailSend.emailName`)} rules={[{
                    required: true,
                    message: `${t(`general.pleaseEnter`)} ${t(`emailSend.emailName`)}`,
                  }]}>
                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label={t(`emailSend.emailTheme`)} name='subject'
                    rules={[{ required: true, message: `${t(`general.pleaseEnter`)} ${t(`emailSend.emailTheme`)}`, pattern: new RegExp(/^[^\|]*$/) }]}
                  >
                    <Input
                      // addonAfter={this.suffixSelector} 
                      style={{ width: '100%', }} placeholder={t(`general.pleaseEnter`)}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label={t(`emailSend.httpImport`)} name='htmlToTemplate'
                    rules={[{ required: false, message: `${t(`general.pleaseEnter`)} ${t(`emailSend.httpImport`)}`, }]}
                  >
                    <Search
                      // defaultValue=""
                      placeholder="http://"
                      allowClear
                      enterButton="解析到正文"
                      onSearch={this.onSearch}
                      loading={isFetchingTo}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="upload"
                    label={t(`emailSend.attachmentUpload`)}
                    valuePropName="fileList"
                    getValueFromEvent={this.normFile}
                    extra="允许常见图片类型、压缩文件、OFFICE文档上传(*.jpg;*.png;*.gif;*.bmp;*.jpeg;*.txt;*.pdf;*.doc;*.docx;*.xls;*.xlsx;*.csv;*.ppt;*.pps;*.pptx;*.ppsx;*.htm;*.html;*.zip;*.rar;*.gz;*.bz2;*.ics;*.mp4;*.mp3) 附件最大允许15M，图片最大允许1M。附件大小和计费有关，请谨慎控制邮件大小！"
                  >
                    <Upload
                      accept=".jpg,.png,.gif,.bmp,.jpeg,.txt,.pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pps,.pptx,.ppsx,.htm,.html,.zip,.rar,.gz,.bz2,.ics,.mp4,.mp3"
                      name="file"
                      action={UPLOAD_TEMPLATE_URL}
                      data={{}}
                      beforeUpload={this.beforeUpload}
                      headers={this.getHeader()}
                      onChange={this.onClickImport}
                      showUploadList={false}
                    >
                      <Button icon={<UploadOutlined />}>点击选择附件</Button>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label={t(`emailSend.emailContent`)} name='content' valuePropName="editorState" getValueFromEvent={v => v}
                    rules={[{ required: false, message: `${t(`general.pleaseEnter`)} ${t(`emailSend.emailContent`)}`, }]}
                  >
                    <JoditEditor
                      value={this.state.content}
                      config={editorConfig}
                      // onBlur={content => {
                      //   this.setState({ content: content })
                      //   // this.formRef.current.setFieldsValue({ content: content })
                      // }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
